import { STEPS_LABELS } from '../../constants';
import { SET_STEP } from '../actions/stepper';

const defaultState = {
  currentStep: STEPS_LABELS.UPLOAD
};

export default function(state = defaultState, action) {
  switch (action.type) {
  case SET_STEP:
    return { ...state, currentStep: action.currentStep };
  default:
    return state;
  }
}
